import { useEffect, useMemo, useState } from 'react';

import { format, formatDistanceToNowStrict, addDays } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { MoonLoader } from 'react-spinners';

import { useAuth } from '~/hooks/auth';
import { useStudent } from '~/hooks/student';
import {
  cellPhoneFormatter,
  cpfFormatter,
  zipCodeFormatter,
} from '~/utils/formatter';

import { Container, Info, Label, Text, AlertContainer } from './styles';

export function Information() {
  const { user } = useAuth();
  const { studentData } = useStudent();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    studentData && setLoading(false);
  }, [studentData]);

  const handleObservation = (observation: string) => {
    const array = observation.split(`/${user.id}`);

    const newObservation = array.find((elem) =>
      elem.includes(`${user.id}&&!!`),
    );
    const regex = new RegExp(`${user.id}&&!!`, 'g');
    if (newObservation) {
      return newObservation.replace(regex, '');
    }
    return '';
  };

  const options = useMemo(() => {
    const genderVariations: { [key: string]: string } = {
      male: 'Masculino',
      female: 'Feminino',
      other: 'Outro',
      others: 'Outro',
      '': 'Não informado',
      null: 'Não informado',
    };

    return [
      {
        id: 1,
        question: 'Data de nascimento:',
        answer: format(
          addDays(new Date(studentData?.student?.birth_date ?? Date.now()), 1),
          'dd/MM/yyyy',
        ),
      },
      {
        id: 2,
        question: 'Idade:',
        answer: formatDistanceToNowStrict(
          new Date(studentData?.student?.birth_date ?? Date.now()),
          { locale: ptBR },
        ),
      },
      {
        id: 3,
        question: 'Gênero:',
        answer: genderVariations[studentData?.student?.genre ?? ''],
      },
      {
        id: 4,
        question: 'CPF:',
        answer: cpfFormatter(studentData?.student.cpf ?? ''),
      },
      { id: 5, question: 'E-mail:', answer: studentData?.email },
      {
        id: 6,
        question: 'Telefone/Celular:',
        answer: cellPhoneFormatter(studentData?.cellphone ?? ''),
      },
      {
        id: 7,
        question: 'CEP:',
        answer: studentData?.address_zip_code
          ? zipCodeFormatter(studentData.address_zip_code)
          : 'Não informado',
      },
      {
        id: 8,
        question: 'Rua:',
        answer: studentData?.address_street || 'Não informado',
      },
      {
        id: 9,
        question: 'Complemento: ',
        answer: studentData?.address_complement || 'Não informado',
      },
      {
        id: 10,
        question: 'Cidade:',
        answer: studentData?.address_city || 'Não informado',
      },
      {
        id: 11,
        question: 'Estado:',
        answer: studentData?.address_state || 'Não informado',
      },
      {
        id: 12,
        question: 'País: ',
        answer: studentData?.address_country || 'Não informado',
      },
      {
        id: 13,
        question: 'Observações: ',
        answer: studentData?.student?.observations
          ? handleObservation(studentData.student.observations)
          : 'Não informado',
      },
    ];
  }, [studentData]);

  const infosMemo = useMemo(
    () =>
      options?.map((item) => (
        <Info key={item.id}>
          <Label>{item.question}</Label>
          <Text>{item.answer}</Text>
        </Info>
      )),
    [options],
  );

  return (
    <Container>
      {loading ? (
        <AlertContainer>
          <MoonLoader size={30} color="#FFDF22" />
        </AlertContainer>
      ) : (
        <>{infosMemo}</>
      )}
    </Container>
  );
}
